define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../models/ProfileModel"], function (require, exports, $, ko, log, urls_1, tools, ProfileModel) {
    "use strict";
    var Profile = /** @class */ (function () {
        function Profile() {
            this.editModel = ko.observable(new ProfileModel());
            this.previewModel = ko.observable(new ProfileModel());
            this.Email = ko.observable();
            this.Password = ko.observable();
            this.ConfirmPassword = ko.observable();
            this.twoFactorTypes = [
                { Value: "GoogleAuthenticator", Text: "Google Authenticator" },
                { Value: "PhoneCode", Text: "Phone Code" },
                { Value: "EmailCode", Text: "Email Code" }
            ];
        }
        Profile.prototype.init = function () {
            var self = this;
            var getModelCall = tools.ajaxGet({
                url: "/Account/GetMyProfile",
                success: function (result) {
                    if (result.Success) {
                        self.previewModel(new ProfileModel(result.Data));
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
            $.when(getModelCall).done(function () {
                $("#contextLoader").hide();
                $("#mainContext").show();
                ko.applyBindings(self, document.getElementById("ko-main-content"));
            });
        };
        Profile.prototype.openEdit = function () {
            var self = this;
            var title = "Edit Profile";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().EMail()) {
                        tools.error("Email is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveProfile(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = tools.ajaxGet({
                        url: "/Account/GetMyProfile",
                        success: function (result) {
                            if (result.Success) {
                                self.editModel(new ProfileModel(result.Data));
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'profile-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        Profile.prototype.saveProfile = function (btn, modal) {
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            var data = {
                Id: obj.Id,
                Login: obj.Login,
                EMail: obj.EMail,
                FirstName: obj.FirstName,
                LastName: obj.LastName,
                ExternalId: obj.ExternalId,
                ApiClientId: obj.ApiClientId,
                ApiKey: obj.ApiKey,
                PhoneNumber: obj.PhoneNumber,
                TwoFactorType: obj.TwoFactorType,
                TwoFactorEnabled: obj.TwoFactorEnabled,
                TOTPSecretKey: obj.TOTPSecretKey,
                emailNotificationsStr: JSON.stringify(obj.EmailNotifications),
                __RequestVerificationToken: $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val()
            };
            tools.ajaxPost({
                url: "/Account/SaveProfile",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    self.previewModel(new ProfileModel(result.Data));
                    tools.success("Changes updated successfully");
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        Profile.prototype.openChangePassword = function () {
            var self = this;
            var title = "Change Password Form";
            tools.editModal({
                title: title,
                buttonTitle: "Change Password",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    var obj = ko.mapping.toJS({
                        OldPassword: self.editModel().OldPassword(),
                        NewPassword: self.editModel().NewPassword(),
                        ConfirmPassword: self.editModel().ConfirmPassword()
                    });
                    if (!obj.OldPassword) {
                        tools.error("Please enter current password.");
                        return;
                    }
                    if (!obj.NewPassword) {
                        tools.error("Please enter a password.");
                        return;
                    }
                    if (!tools.isValidPassword(obj.NewPassword)) {
                        return;
                    }
                    if (obj.NewPassword !== obj.ConfirmPassword) {
                        tools.error("The confirmation password does not match.");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveUserPassword(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = tools.ajaxGet({
                        url: "/Account/GetMyProfile",
                        success: function (result) {
                            if (result.Success) {
                                self.editModel(new ProfileModel(result.Data));
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'profile-change-password-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        Profile.prototype.saveUserPassword = function (btn, modal) {
            var self = this;
            var obj = {
                Id: self.editModel().Id(),
                OldPassword: self.editModel().OldPassword(),
                NewPassword: self.editModel().NewPassword(),
                ConfirmPassword: self.editModel().ConfirmPassword()
            };
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/Account/ChangePassword",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    if (result.Data) {
                        tools.success("Password changed successfully");
                    }
                    else {
                        tools.error("Password change failed");
                    }
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        return Profile;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Account/Manage")) {
            log.log("Initialize Profile");
            $(function () {
                (new Profile()).init();
            });
        }
    }, 0);
    return Profile;
});
//# sourceMappingURL=profile.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/account/profile.js
// module id = 287
// module chunks = 2